import ArrowButtonHome from "~/assets/icons/ArrowButtonHome";
import { twoCollections } from "../../../setup/settings/index";

export function TwoCollections() {
  const { leftCollection, rightCollection } = twoCollections;
  return (
    <div className="billboardHome__container">
      {twoCollections.title &&
        <div className="billboardHome__title">
          <h3>{twoCollections.title}</h3>
          <p className='subtitle'>{twoCollections.subtitle}</p>
        </div>
      }
      <div className="billboardHome__grid grid sm:grid-cols-2 gap-10">

        <div className="billboardHome__card cardLeft">
          <div className="billboardHome__imageArea">
            <div className="billboardHome__image">
              <a href={`${leftCollection.href}`}><img src={leftCollection.imageUrl} /></a>
            </div>
            <div className="billboardHome__name">
              <h4>{leftCollection.title}</h4>
              <p className='subtitle'>{leftCollection.subtitle}</p>
            </div>
            <div className="billboardHome__button">
              <a className="billboardHome__btn" href={`${leftCollection.href}`}><button>{leftCollection.textButton}</button><ArrowButtonHome /></a>
            </div>
          </div>
        </div>

        <div className="billboardHome__card cardRight">
          <div className="billboardHome__imageArea">
            <div className="billboardHome__image">
              <a href={`${rightCollection.href}`}><img src={rightCollection.imageUrl} /></a>
            </div>
            <div className="billboardHome__name">
              <h4>{rightCollection.title}</h4>
              <p className='subtitle'>{rightCollection.subtitle}</p>
            </div>
            <div className="billboardHome__button">
              <a className="billboardHome__btn" href={`${rightCollection.href}`}><button>{rightCollection.textButton}</button><ArrowButtonHome /></a>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};